import { render, staticRenderFns } from "./bloggerMore.vue?vue&type=template&id=1054cdf1&scoped=true&"
import script from "./bloggerMore.vue?vue&type=script&lang=js&"
export * from "./bloggerMore.vue?vue&type=script&lang=js&"
import style0 from "./bloggerMore.vue?vue&type=style&index=0&id=1054cdf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054cdf1",
  null
  
)

export default component.exports